define(['angular', '../module'], function(angular, MODULE_NAME) {
    'use strict';

    var $ = angular.element,
        CONTROLLER_NAME = 'IlmnUiCommentsModalCtrl';

    angular.module(MODULE_NAME)
        .controller(CONTROLLER_NAME, IlmnUiCommentsModalCtrl);

    IlmnUiCommentsModalCtrl.$inject = ['$q', '$timeout', '$uibModalInstance', 'ilmnUiConfirmDialogService', 'options', '$uibModalStack', '$ilmnUiAlertBannerService'];
    function IlmnUiCommentsModalCtrl($q, $timeout, $modalInstance, confirmDialogSvc, options, $uibModalStack, $ilmnUiAlertBannerService) {
        var vm = this,
            animationTiming = 250;

        var defaults = {
            comments: [],
            add: noop,
            edit: noop,
            delete: noop,
            maxLength: 1024
        };

        $timeout(function(){
            $ilmnUiAlertBannerService.show({
                message: "Direct identifiers should not be stored in custom fields",
                overlay: false,
                prependTo: '.modal',
                type: 'notify',
                dismissible: true
            });
        });

        angular.extend(vm, defaults, options);

        vm.close = close;
        vm.cancel = cancel;
        vm.saveComment = saveComment;
        vm.selectComment = selectComment;
        vm.deleteComment = deleteComment;

        init();

        //////////////////////////////////

        function init() {
            resetForm();
        }

        function selectComment(comment, $event) {
            vm.selectedComment = comment;
            vm.editableComment = comment.comments;
            animateEditSelection($event);
        }

        function close() {
            $uibModalStack.dismissAll();
        }

        function cancel(evt) {
            if(vm.commentsForm.$dirty) {
                return confirmDialogSvc.show({
                    appendTo: $(evt.currentTarget).parent()
                }, {
                    message: 'Do you want to cancel edits to this comment?'
                }).then(resetForm);
            }

            if (vm.commentsForm.$pristine && !vm.editableComment){
                close();
            }

            resetForm();
        }

        function saveComment() {
            if(vm.selectedComment.id) {
                editComment(vm.selectedComment);
            }
            else {
                addComment({ comments: vm.editableComment });
            }
        }

        function addComment(comment) {
            vm.add(comment)
                .then(function(item) {
                    vm.comments.unshift(item);
                    resetForm();

                    $timeout(function() {
                        animateComment(item);
                    }, 10);
                }, showApiErrorBanner);
        }

        function deleteComment(comment, index, $event) {
            var dialog = confirmDialogSvc.show({
                appendTo: $($event.currentTarget).parent().parent()
            }, {
                message: 'Delete this comment? Proceeding will not delete any associated events.'
            });
            dialog.backdrop = false;
            dialog.then(function() {
                vm.updatingComment = comment.id;

                vm.delete(comment)
                    .then(function() {
                        vm.comments.splice(index, 1);
                        delete vm.updatingComment;
                    }, showApiErrorBanner);
            });
        }

        function showApiErrorBanner(resp) {
            delete vm.updatingComment;
            vm.serviceError = true;

            $ilmnUiAlertBannerService.show({
                message: resp.data || "Comments service is unavailable.",
                overlay: false,
                prependTo: '.modal-content',
                type: 'danger'
            });
        }

        function resetForm() {
            vm.selectedComment = {};
            vm.editableComment = '';
            vm.commentsForm && vm.commentsForm.$setPristine();
        }

        function editComment(comment) {
            var updatedComment = angular.extend({}, comment, {comments: vm.editableComment});
            vm.updatingComment = comment.id;

            vm.edit(updatedComment)
                .then(function(updates) {
                    delete vm.updatingComment;

                    angular.extend(comment, updates);
                    animateComment(comment);
                    resetForm();
                    // Commit changes to the UI
                }, showApiErrorBanner);
        }

        function animateComment(comment) {
            comment.class = 'new-row';
            $timeout(function() {
                delete comment.class;
            }, 2500);
        }

        function animateEditSelection(evt) {

            var eventTarget     = $(evt.currentTarget),
                editingRow      = eventTarget.parents('tr'),
                modalDiv        = eventTarget.parents('div.modal-dialog'),
                allRows         = modalDiv.find('tbody tr'),

                rowPosition     = 0,
                rowHeight       = Math.round(editingRow.height()),
                viewPortHeight  = Math.round(modalDiv.find('tbody').height()),
                scrollDistance;

            // Set row to editing
            editingRow.toggleClass('editing');

            // Calculate height of rows up till the editing row
            $.each(allRows, function () {
                if (!$(this).hasClass('editing')) {
                    rowPosition += $(this).height();
                } else {
                    return false;
                }
            });

            if (rowPosition === 0) {
                scrollDistance = 0;
            } else {
                scrollDistance = (rowPosition + (rowHeight / 2)) - (viewPortHeight / 2);
            }

            // Scroll to position of row being edited
            modalDiv.find('.modal-comments-table tbody').animate({
                scrollTop: scrollDistance
            }, animationTiming);
        }

        function noop(item) {
            return $q.resolve(item);
        }

    }

    return CONTROLLER_NAME;
});



//////////////////
// WEBPACK FOOTER
// ./ilmn-ui-comments/scripts/commentsModal.controller.js
// module id = 24
// module chunks = 0